/**
 * A cova do legado (`TombView`): um corpo físico com a caixa (-3, 3, 6, 3) em volta do ponto dela. Ela cai até a caixa tocar o chão. A imagem (38×41) fica em (-15, -37)
 * em relação ao ponto, e ao parar a cova gira para a inclinação do chão (`stopMoving`). A explosão de qualquer bomba a menos de 100 px a faz cair de novo (`SimpleBomb.bomb`).
 */
export const TOMB_BOX = { x: -3, y: 3, w: 6, h: 3 };
export const TOMB_IMAGE_OFFSET = { x: -15, y: -37 };
export const TOMB_WAKE_RADIUS = 100;

export type SolidAt = (x: number, y: number) => boolean;

/** A caixa de colisão da cova no ponto (x, y) toca o chão. */
export function tombHitsGround(solid: SolidAt, x: number, y: number): boolean {
  for (let dx = 0; dx < TOMB_BOX.w; dx++) {
    for (let dy = 0; dy < TOMB_BOX.h; dy++) {
      if (solid(x + TOMB_BOX.x + dx, y + TOMB_BOX.y + dy)) return true;
    }
  }
  return false;
}

/**
 * Desce a cova de `y` até `target`, de 1 em 1 px como o legado: a caixa nunca atravessa uma camada fina de chão. Para no último ponto em que o próximo passo bateria no chão.
 * Se a caixa já está dentro do chão, ela não anda (o legado também a deixa onde nasceu).
 */
export function fallTomb(solid: SolidAt, x: number, y: number, target: number): { y: number; landed: boolean } {
  let current = y;
  while (current < target) {
    const next = Math.min(target, Math.floor(current) + 1);
    if (tombHitsGround(solid, x, Math.floor(current) + 1)) return { y: current, landed: true };
    current = next;
  }
  return { y: current, landed: false };
}
